var _excluded = ["as", "children", "classes", "italic", "transform", "weight"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { StyledTypography, StyledText } from './StyleText';
function Text(_ref) {
  var as = _ref.as,
    children = _ref.children,
    classes = _ref.classes,
    italic = _ref.italic,
    transform = _ref.transform,
    weight = _ref.weight,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var otherProps = {
    italic: italic,
    transform: transform,
    weight: weight
  };
  return /*#__PURE__*/React.createElement(StyledTypography, _extends({
    component: as,
    className: classes,
    variant: as
  }, rest), /*#__PURE__*/React.createElement(StyledText, otherProps, children));
}
Text.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Defines the alignment of text
   */
  align: PropTypes.oneOf(['center', 'inherit', 'justify', 'left', 'right']),
  /**
   * HTML element to render as
   */
  as: PropTypes.oneOf(['div', 'p', 'span']),
  /**
   * Defines the color of the component.
   * Supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),
  /**
   * Controls the display type
   */
  display: PropTypes.oneOf(['block', 'inline']),
  /**
   * Truncate a single line of text with an ellipsis if it overflows its container.
   */
  noWrap: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node.isRequired,
  /**
   * Extend the classes to creates extra styles of the component.
   */
  classes: PropTypes.string,
  /**
   * Make font appearence italic
   */
  italic: PropTypes.bool,
  /**
   * If `true`, the text will have a bottom margin.
   */
  paragraph: PropTypes.bool,
  /**
   * Defines the capitalization of text.
   */
  transform: PropTypes.oneOf(['none', 'capitalize', 'lowercase', 'uppercase']),
  /**
   * Applies the theme typography styles
   */
  variant: PropTypes.oneOf(['subtitle1', 'body1', 'body2', 'inherit']),
  /**
   * Defines font weight of element
   */
  weight: PropTypes.oneOf(['300', '400', '500', '600', '700', '800'])
} : {};
Text.defaultProps = {
  align: 'left',
  as: 'p',
  color: 'inherit',
  display: 'block',
  noWrap: false,
  classes: '',
  italic: false,
  paragraph: false,
  transform: 'none',
  weight: '500',
  variant: 'body1'
};
export default Text;